import { LlmHistoryNode, LlmHistoryService } from '@adaptiva/ai/common';
import { Box, IBox, IBoxed, Vector2 } from '@adaptiva/core/space';
import { IconComponent } from '@adaptiva/widgets/icon';
import { Component, computed, ElementRef, inject, input, InputSignal, model, ModelSignal, Signal } from '@angular/core';

@Component({
	selector: '[ada-llm-history-node]',
	templateUrl: './llm-history-node.component.html',
	styleUrl: './llm-history-node.component.scss',
	imports: [IconComponent]
})
export class LlmHistoryNodeComponent implements IBoxed {

	public readonly node: InputSignal<LlmHistoryNode | null> = input(null);

	public readonly isExpanded: ModelSignal<boolean> = model(true);

	public readonly elementRef: ElementRef<HTMLElement> = inject(ElementRef);

	protected readonly history: LlmHistoryService = inject(LlmHistoryService);

	protected readonly shouldShowButton: Signal<boolean> = computed(() => {
		const _node: LlmHistoryNode | null = this.history.nodes().get(this.node()?.nodeId);

		return !(this.isExpanded() && !_node?.children.length);
	});

	public getBox(): IBox {
		const _domRect: DOMRect = this.elementRef.nativeElement.getBoundingClientRect();

		return new Box({
			topLeft: new Vector2(_domRect.left, _domRect.top),
			bottomRight: new Vector2(_domRect.right, _domRect.bottom)
		});
	}

	public toggle(): void {
		this.isExpanded.update(x => !x);
	}

}
